// inputElementId, inputErrorClass, errorMessage

class ErrorMessage {
	constructor(config) {
		this.config = config;
		this.errorText = this.config.errorText;
		this.inputErrorClass = this.config.inputErrorClass;
		this.errorMesssageClass = this.config.errorMesssageClass;
		this.inputElement = document.querySelector(`#${this.config.inputElementId}`);
		this.inputWrapper = this.inputElement.parentNode;
		this.errorMesssageExists = this.inputElement.classList.contains(this.inputErrorClass);
	}

	_errorMessageTemplate(errorText) {
		return `
		<svg  aria-hidden="true" width="16" height="16" class="c-inputgroup__validation-icon c-inputgroup__validation-icon--errored">
				<use xlink:href="/img/svg-sprite.svg#icon-error"></use>
		</svg>
		<span>${errorText}</span>`;
	}

	_showMessage() {
		if (this.errorMesssageExists) {
			this.inputWrapper.lastElementChild.innerHTML = this._errorMessageTemplate(this.errorText);
		} else {
			this.inputElement.classList.add(this.inputErrorClass);
			this.inputElement.setAttribute('aria-invalid', true);
			this.inputWrapper.append(this._createContainer());
		}
	}

	_hideMessage() {
		this.inputElement.classList.remove(this.inputErrorClass);
		this.inputElement.setAttribute('aria-invalid', false);
		this.inputWrapper.lastElementChild.remove();
	}

	_toggleMessage(inputValidates) {
		if (inputValidates) {
			this._hideMessage();
		} else {
			this._showMessage();
		}
	}

	_createContainer() {
		const messageWrapper = document.createElement('p');

		messageWrapper.className = this.errorMesssageClass;
		messageWrapper.innerHTML = this._errorMessageTemplate(this.errorText);

		return messageWrapper;
	}

	init(inputValidates) {
		if (inputValidates && !this.errorMesssageExists) {
			return false;
		}

		this._toggleMessage(inputValidates);
	}
}

export default ErrorMessage;
